import { render } from "./EditContactDialog.vue?vue&type=template&id=04d51a18&scoped=true"
import script from "./EditContactDialog.vue?vue&type=script&lang=js"
export * from "./EditContactDialog.vue?vue&type=script&lang=js"

import "./EditContactDialog.vue?vue&type=style&index=0&id=04d51a18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d51a18"]])

export default __exports__